<template>
    <div class="flex">
        <div class="w-full md:w-1/2 h-screen bg-white">
            <div class="flex flex-wrap flex-col h-screen content-center justify-center bg-white">
                <div class="w-full">
                    <form class="px-8 pt-6 pb-8 mb-4">
                        <h1 class="text-6xl font-bold">Aerobile Retailers</h1>
                        <p class="mt-0 mb-10 text-gray-600">Login with email and password.</p>
                        <div class="mb-4">
                            <label class="block text-gray-700 text-sm font-bold mb-2">
                                Email
                            </label>
                            <input class="appearance-none rounded w-full py-4 px-6 bg-gray-200 text-gray-700 leading-tight"
                                   type="text"
                                   placeholder="Email"
                                   v-model="email">
                        </div>
                        <div class="mb-6">
                            <label class="block text-gray-700 text-sm font-bold mb-2" for="password">
                                Password
                            </label>
                            <input class="appearance-none rounded w-full py-4 px-6 bg-gray-200 text-gray-700 mb-3 leading-tight"
                                   type="password"
                                   placeholder="Password"
                                   v-model="password">
                        </div>
                        <div class="mb-6 flex items-center justify-between">
                            <div class="flex items-center">
                                <input  v-model="isRetailer"
                                        id="is-retailer" name="is_retailer" type="checkbox"
                                        class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded">
                                <label for="is-retailer" class="ml-2 block text-sm text-gray-900">
                                    I'm a retailer
                                </label>
                            </div>
                        </div>
                        <div class="flex items-center justify-between">
                            <vue-recaptcha
                                ref="recaptcha"
                                size="invisible"
                                :sitekey="reCaptchaSiteKey"
                                @verify="onCaptchaVerified"
                                @expired="onCaptchaExpired">
                                <button class="bg-blue-500 hover:bg-blue-700 disabled:opacity-50 text-white font-bold py-4 px-6 rounded focus:outline-none focus:shadow-outline"
                                        type="button"
                                        :disabled="!dataIsFilled">
                                    Sign In
                                </button>
                            </vue-recaptcha>
                        </div>
                    </form>
                    <p class="text-center text-gray-500 text-xs">
                        &copy;2020 Aerobile LLC. All rights reserved.
                    </p>
                </div>
            </div>
        </div>
        <div class="hidden md:block w-1/2 h-screen bg-cover bg-no-repeat bg-center"
             :style="{
                 'background-image': `url(${require('../assets/images/hero-1-min.jpg')}`,
                }"></div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import VueRecaptcha from 'vue-recaptcha';

export default {

    components:{
        VueRecaptcha
    },

    data() {

        return {
            reCaptchaSiteKey: window.recaptchaSiteKey,
            email: null,
            password: null,
            isRetailer: false,
        }

    },

    computed: {
        dataIsFilled() {
            return this.email && this.password;
        }
    },

    methods: {
        ...mapActions(
             'auth',
            [
                'login',
                'logout',
            ]
        ),

        triggerLogin(recaptchaToken) {
            return this.login({
                email: this.email,
                password: this.password,
                recaptchaToken: recaptchaToken,
                isRetailer: this.isRetailer,
            });
        },

        onCaptchaVerified (recaptchaToken) {

          this.$refs.recaptcha.reset();
          this.triggerLogin(recaptchaToken);

        },

        onCaptchaExpired () {
            this.$refs.recaptcha.reset();
        },
    },

    created() {
        this.logout();
    },


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
